/**
 * EditAction types for tracking
 */
export const ActionCardOptions = {
  EDIT: 'edit',
  DELETE: 'delete',
  DELETE_ALL: 'delete all',
  MOVE: 'move',
  MOVE_ALL: 'move all',
  CLONE: 'clone',
  CLONE_ALL: 'clone all'
};